<script lang="ts">
  import type { Snippet } from 'svelte';
  import clsx from 'clsx';
  import { useDropdown } from './useDropdown.svelte';

  type Props = {
    label: string;
    value: string;
    disabled?: boolean;
    children?: Snippet;
    class?: string;
  };

  const { label, value, disabled, class: className, children }: Props = $props();
  const { selected, handleKeyDown, handleClick } = useDropdown();
</script>

<li
  role="option"
  tabindex={-1}
  onclick={handleClick}
  onkeydown={handleKeyDown}
  data-label={label}
  data-value={value}
  data-disabled={disabled || undefined}
  aria-disabled={disabled || undefined}
  aria-selected={value === selected()?.value}
  class={clsx('px-4 py-2 data-[disabled]:cursor-not-allowed', className)}
>
  {@render children?.()}
</li>
